export default __webpack_public_path__ + "static/media/dieppe19.3c01cf1a.jpg";